import LazyChartControllerBase from './helpers/lazy_chart_controller_base';
import { ChartFormattingMixin } from './concerns/chart_formatting_mixin';
import Chart from 'chart.js/auto';

export default class extends LazyChartControllerBase {
  static values = { inputs: String, dataFormat: String, startAtZero: Boolean, maxYTicks: Number, maxXTicks: Number, barRadius: Number };
  static targets = ['chartcanvas'];

  _buildChart() {
    const chartData = JSON.parse(this.inputsValue);
    Object.assign(this, ChartFormattingMixin);

    new Chart(this.chartcanvasTarget, {
      type: 'bar',
      data: chartData,
      options: this.chartOptions(chartData),
    });
  }

  chartOptions(chartData) {
    return {
      responsive: true,
      maintainAspectRatio: false,
      height: 150,
      elements: {
        bar: {
          borderRadius: this.barRadiusValue || 20,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: this.tooltipFormat(),
          },
        },
      },
      scales: {
        y: {
          grace: this.setGrace(chartData.datasets),
          min: this.setMin(),
          beginAtZero: this.startAtZeroValue,
          display: true,
          border: { display: false },
          grid: {
            display: false,
          },
          ticks: {
            callback: this.ticksFormat(),
            maxTicksLimit: this.hasMaxYTicksValue ? this.maxYTicksValue : undefined,
          },
        },
        x: {
          ticks: {
            color: '#808191',
            maxTicksLimit: this.hasMaxXTicksValue ? this.maxXTicksValue : undefined,
          },
          border: { display: false },
        },
      },
    };
  }

  setMin() {
    if (this.startAtZeroValue == true) {
      return 0;
    }
  }
}
